var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"AdvantageImg"},on:{"click":_vm.handleClick}},[_c('img',{attrs:{"src":require('@/' + _vm.src),"alt":"安评"}}),_c('div',{staticClass:"article"},[_c('div',[_c('i',{class:_vm.icon}),_c('p',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"content"},[_vm._v(_vm._s(_vm.content))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }